import { AppBar, Box, Container, Link, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { LanguageSelector } from '@/components/common/LanguageSelector';

/** Mobile-first public shell: brand bar with language selector, narrow content column. */
export function PublicLayout() {
  const { ui } = useLanguage();
  return (
    <Box minHeight="100dvh" display="flex" flexDirection="column" bgcolor="background.default">
      <AppBar position="static" elevation={0} sx={{ bgcolor: 'primary.main' }}>
        <Toolbar sx={{ maxWidth: 760, width: '100%', mx: 'auto', px: 2, minHeight: 60, gap: 2 }}>
          <Link component={RouterLink} to="/" underline="none" color="inherit" sx={{ flex: 1, lineHeight: 1.15 }}>
            <Typography fontWeight={700} fontSize="1.05rem" component="div">
              {ui('app.title')}
            </Typography>
            <Typography fontSize="0.78rem" sx={{ opacity: 0.9 }} component="div">
              {ui('app.subtitle')} · {ui('app.tagline')}
            </Typography>
          </Link>
          <LanguageSelector light />
        </Toolbar>
      </AppBar>

      <Container component="main" maxWidth="sm" sx={{ flex: 1, py: { xs: 2, sm: 3 }, px: 2 }}>
        <Outlet />
      </Container>

      <Box component="footer" textAlign="center" px={2} py={2}>
        <Typography variant="caption" color="text.secondary" display="block">
          {ui('app.footer')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <Link component={RouterLink} to="/privacidad">{ui('nav.privacy')}</Link> ·{' '}
          <Link component={RouterLink} to="/login">{ui('nav.staff')}</Link>
        </Typography>
      </Box>
    </Box>
  );
}
